<index [fromParentDate]="date" [fromParentDuration]="duration" [fromParentAppointment]="appointment" (messageEvent)="receiveMessage($event)"></index>
